import { parsePhoneNumberFromString } from "libphonenumber-js";

/** E.164 digits only (no +), safe for OTP URL path and API payloads */
export function toInternationalDigits(raw: string): string | null {
  const t = raw.trim();
  if (!t) return null;
  const e164ish = t.startsWith("+") ? t : `+${t.replace(/\D/g, "")}`;
  const p = parsePhoneNumberFromString(e164ish);
  if (!p?.isValid()) return null;
  return p.format("E.164").replace(/\D/g, "");
}

/** Human-readable international format from digits-only string */
export function formatInternationalDigits(digitsOnly: string): string {
  const d = digitsOnly.replace(/\D/g, "");
  if (!d) return "";
  const p = parsePhoneNumberFromString(`+${d}`);
  return p?.formatInternational() ?? `+${d}`;
}

/** Path segment + body.countryCode for OTP send API */
export function splitInternationalDigits(digitsOnly: string): {
  nationalNumber: string;
  countryCallingCode: string;
} | null {
  const d = digitsOnly.replace(/\D/g, "");
  if (!d) return null;
  const p = parsePhoneNumberFromString(`+${d}`);
  if (!p?.isValid()) return null;
  return {
    nationalNumber: p.nationalNumber,
    countryCallingCode: String(p.countryCallingCode),
  };
}
